module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/bg_mv-pc-7d0618a1b2acd260e631b377fc174541.jpg";